import { render, staticRenderFns } from "./NotificationTemplateSetup.vue?vue&type=template&id=898705ce&scoped=true"
import script from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplateSetup.vue?vue&type=style&index=0&id=898705ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898705ce",
  null
  
)

export default component.exports